module.exports = __webpack_public_path__ + "static/media/19ESCAP29.fdf388c4.jpg";